import { api } from "../api";

/**
 * logoutUser - Function that tries to logout an user  
 * /authenticator/logout  
 * method DELETE 
 * @async-function
 */
const logoutUser = async (userId: number, token: String) => {
  const response = await api.delete(
    `authenticator/logout/${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  );

  return response;
};

export default logoutUser;
